define('global/UI/SetupClickMenu',[
	'jquery',
    'global/Logger',
    "./Helpers",
    'plugins/clickmenu'
], function ($, Logger, Helpers, clickmenu) {
    'use strict';
    Logger.debug('Setting up ClickMenu ...');

    // Initialize clickMenu.
    $( document ).ready(function() {
        $(".main-nav").clickMenu({
            animationSpeed: 400,
        });
    });

    // Click the actual toggle button from clickMenu on mobile screens.
    // And run clickMenuFirstDropdownMobileHandler();
    $(".headerMenuToggle .toggle-menu").click(function (e) {
        e.preventDefault();
        $(".main-nav .toggle-menu").click();
    })

    // Closing Menu on resize.
    var closeMenuHandler = Helpers.debounce(function () {
        if ($("html").hasClass("cm-js-menu-active")) { $('.toggle-menu').click() };
    }, 10);
    $(window).on("resize", closeMenuHandler);

	$(window).bind("load resize", function(e) {
		if ($(window).width() > 991) {
			$(window).click(function() {
				$('.main-nav li.opened.animated').removeClass("opened animated");	
			});

			$('.main-nav').click(function(event){
				event.stopPropagation();
			});
		}				
	});		

	
    // Opening first dropdown on large screens
    //var clickMenuFirstDropdownLargeHandler = Helpers.debounce(function () {
    //    if (Helpers.resizeObject.windowWidth >= Helpers.constantsObject.screenMediumMin && !$(".cm-menu > li:first-child").hasClass("opened") ) {
    //        $(".cm-menu > li:first-child a").click()
    //    } else if (Helpers.resizeObject.windowWidth < Helpers.constantsObject.screenMediumMin && $(".cm-menu > li:first-child").hasClass("opened")) {
    //        $(".cm-menu > li:first-child a").click()
    //    }
    //}, 10);
    //clickMenuFirstDropdownLargeHandler();
    //$(window).on("resize", clickMenuFirstDropdownLargeHandler);

});

